import React from "react";
import { HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FiClock, FiUser } from "react-icons/fi";
import { Header } from "build-ts/metadata";
import { epochConverterWithTimeZone } from "utils/dateUtils";
import { useUser } from "context/UserContext";

interface ListItemMetaProps {
  header: Header;
  selected: boolean;
}

/**
 * Bottom-right strip: author + datetime (clock icon only, no “Last modified” label).
 * Parent should place this with mt="auto" inside a column pill so title stays top.
 */
const ListItemMeta: React.FC<ListItemMetaProps> = ({ header, selected }) => {
  const { defaultTimeZone } = useUser();
  const author = header.author_name?.trim() || "Unknown author";
  const when = header?.last_modified_date_ms ? epochConverterWithTimeZone(header?.last_modified_date_ms, "d MMM yyyy, HH:mm", defaultTimeZone) : "";
  const iconColor = selected ? "whiteAlpha.750" : "gray.400";
  const textColor = selected ? "whiteAlpha.900" : "gray.600";
  const mutedColor = selected ? "whiteAlpha.850" : "gray.500";

  return (
    <VStack
      justify="flex-end"
      align="flex-end"
      spacing={3}
      flexWrap="wrap"
      w="full"
      rowGap={1}
      columnGap={3}
      lineHeight={1.2}
    >
      <HStack spacing={1} align="center" flexShrink={0}>
        <Icon as={FiUser} boxSize={3} flexShrink={0} color={iconColor} aria-hidden />
        <Text fontSize="xs" fontWeight="500" color={textColor} noOfLines={1} mb={0}>
          {author}
        </Text>
      </HStack>
      <HStack spacing={1} align="center" flexShrink={0}>
        <Icon as={FiClock} boxSize={3} flexShrink={0} color={iconColor} aria-hidden />
        <Text fontSize="xs" fontWeight="500" color={mutedColor} noOfLines={1} mb={0}>
          {when}
        </Text>
      </HStack>
    </VStack>
  );
};

export default ListItemMeta;
